import {
  convertIFlatEndorsementConfigResponseToIFlatEndorsementConfigData,
  IFlatEndorsementConfigData,
  IFlatEndorsementConfigResponse,
} from './IFlatEndorsementConfig';
import {
  convertILoanCalcEndorsementConfigResponseToILoanCalcEndorsementConfigData,
  ILoanCalcEndorsementConfigData,
  ILoanCalcEndorsementConfigResponse,
} from './ILoanCalcEndorsementConfig';
import {
  convertIPolicyCalcEndorsementConfigResponseToIPolicyCalcEndorsementConfigData,
  IPolicyCalcEndorsementConfigData,
  IPolicyCalcEndorsementConfigResponse,
} from './IPolicyCalcEndorsementConfig';

export interface IEndorsementConfigResponse {
  flatEndorsements: IFlatEndorsementConfigResponse[];
  loanCalcEndorsements: ILoanCalcEndorsementConfigResponse[];
  policyCalcEndorsements: IPolicyCalcEndorsementConfigResponse[];
}

export interface IEndorsementConfigData {
  flatEndorsements: IFlatEndorsementConfigData[];
  loanCalcEndorsements: ILoanCalcEndorsementConfigData[];
  policyCalcEndorsements: IPolicyCalcEndorsementConfigData[];
}

export const convertIEndorsementConfigResponseToIEndorsementConfigData = ({
  flatEndorsements,
  loanCalcEndorsements,
  policyCalcEndorsements,
}: IEndorsementConfigResponse): IEndorsementConfigData => ({
  flatEndorsements: flatEndorsements.map(convertIFlatEndorsementConfigResponseToIFlatEndorsementConfigData),
  loanCalcEndorsements: loanCalcEndorsements.map(
    convertILoanCalcEndorsementConfigResponseToILoanCalcEndorsementConfigData
  ),
  policyCalcEndorsements: policyCalcEndorsements.map(
    convertIPolicyCalcEndorsementConfigResponseToIPolicyCalcEndorsementConfigData
  ),
});
